import { useMutation, useQueryClient } from "@tanstack/react-query";
import { restoreGuardian as apiFn } from "../../api/apiGuardians";
import { useSnackbar } from "notistack"; import getErrorMessageFromAxiosError from "../../utils/parseError";
export function useRestoreGuardian() { const qc = useQueryClient(); const { enqueueSnackbar } = useSnackbar();
    const { mutate: restoreGuardian, isPending: isRestore } = useMutation({ mutationFn: (id) => apiFn(id),
        onSuccess: (r) => { enqueueSnackbar(r.message, { variant: "success" }); qc.invalidateQueries({ queryKey: ["guardians"] }); },
        onError: (err) => { enqueueSnackbar(getErrorMessageFromAxiosError(err), { variant: "error" }); } });
    return { restoreGuardian, isRestore }; }
